import axios from "axios";

const baseURL = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/api`

const inctance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

inctance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

inctance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default inctance;
